import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search-view-phone" }

import { onBeforeUnmount, onMounted, ref } from 'vue';

import useContext from '@/composables/useContext';
import { getSearchContext } from '@/composables/useSearch';

import SearchViewInput from './SearchViewInput.vue';
import SearchViewPhoneResults from './SearchViewPhoneResults.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchViewPhone',
  setup(__props) {

const { mitt } = useContext();
const { searchResult } = getSearchContext();

const searchViewPhoneContent = ref<HTMLDivElement | null>(null);

onMounted(() => {
  window.addEventListener('click', closeIfClickIsOutsideOfSearchOverlay);
  mitt.emit('focus-search-input');
});

onBeforeUnmount(() => {
  window.removeEventListener('click', closeIfClickIsOutsideOfSearchOverlay);
});

function closeIfClickIsOutsideOfSearchOverlay(e: any) {
  if (!searchViewPhoneContent.value?.isSameNode(e.target)) return;
  const children = [...searchViewPhoneContent.value?.getElementsByTagName('*')];
  if (
    children.filter((c) => !c.classList.contains('jsPhoneNoSearchResults'))
      .length > 0
  )
    return;

  mitt.emit('close-search');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SearchViewInput, { class: "search-view-phone__input" }),
    _createElementVNode("div", {
      class: "search-view-phone__content",
      ref_key: "searchViewPhoneContent",
      ref: searchViewPhoneContent
    }, [
      _createVNode(SearchViewPhoneResults, { "search-result": _unref(searchResult) }, null, 8, ["search-result"])
    ], 512)
  ]))
}
}

})